import {config} from 'rxjs';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import '../helper/pollyfill/Array';
import '../helper/pollyfill/EventTarget';
import '../helper/pollyfill/Map.js';
import {
  openWS,
  wsStatus$,
  toUiMsg$,
  uiMsg$,
  currencies$,
  contracts$,
  spots$,
  riskLimits$,
  leverages$,
  marginCurrencies$,
  marginPairs$,
  marginRiskLevels$,
  leverageMargins$,
  riskEngineMode$,
  contractCollateralsCache$,
  contractCollateralLiquility$,
  subscribeAssets,
  subscribeContractAccount,
  subscribeKline,
  subscribeMarketContract,
  subscribeMarketSpot,
  subscribePosition,
  subscribeSpotWallet,
  subscribeTick,
  subscribeMarginTrade,
  subscribeSpotTotalAssets,
  subscribeContractTotalAssets,
  subscribeFiatTotalAssets,
  subscribeFiatAccount,
  subscribeInvestmentTotalAssets,
  subscribeLaunchPool,
  subscribePredictProject,
  subscribeInvestment,
  subscribeIndexPrice,
  subscribePredictTotalAssets,
  subscribeLaunchPoolAssets,
  subscribeSpotTradingBotsTotalAssets,
  subscriberUsers,
  subscribeBusinessDutchAuction,
  subscribeLendingAccount,
  subscribeSpotPtState,
  subscribeContractPtState,
} from '@px/ws-data';

import type {UWsUrl} from '@px/ws-data';

subscribeAssets();
subscribeContractAccount();
subscribeKline();
subscribeMarketContract();
subscribeMarketSpot();
subscribePosition();
subscribeSpotWallet();
subscribeTick();
subscribeMarginTrade();

subscribeSpotTotalAssets();
subscribeContractTotalAssets();
subscribeFiatTotalAssets();
subscribeFiatAccount();
subscribeInvestmentTotalAssets();
subscribeLaunchPool();
subscribePredictProject();
subscribeInvestment();
subscribeIndexPrice();
subscribePredictTotalAssets();
subscribeLaunchPoolAssets();
subscribeSpotTradingBotsTotalAssets();
subscriberUsers();
subscribeLendingAccount();

subscribeBusinessDutchAuction();
subscribeSpotPtState();
subscribeContractPtState();

config.onUnhandledError = function (error) {
  if (error.type === 'close') {
    console.warn('ws close');
    return;
  }

  console.warn('rxjs error', error);
};

// @ts-ignore
uiMsg$
  .pipe(filter((o) => o.type === 'foundation-data'))
  .subscribe(({currencies, contracts, spots, riskLimits, leverages, marginCurrencies, marginPairs, marginRiskLevels, leverageMargins, contractCollateralsCache, contractCollateralLiquility}) => {
    currencies$.next(currencies);
    contracts$.next(contracts);
    spots$.next(spots);
    riskLimits$.next(riskLimits);
    leverages$.next(leverages);
    marginCurrencies$.next(marginCurrencies);
    marginPairs$.next(marginPairs);
    marginRiskLevels$.next(marginRiskLevels);
    leverageMargins$.next(leverageMargins);
    contractCollateralsCache$.next(contractCollateralsCache);
    contractCollateralLiquility$.next(contractCollateralLiquility);

    toUiMsg$.next({type: 'worker-ready'});
  });

uiMsg$
  .pipe(
    // @ts-ignore
    filter((o) => o.type === 'ws-url'),
    map((o: UWsUrl) => o.url),
    distinctUntilChanged()
  )
  .subscribe(openWS);

uiMsg$
  .pipe(
    filter((o) => o.type === 'risk-engine-mode'),
    map((o) => o.data)
  )
  .subscribe((o) => riskEngineMode$.next(o));

wsStatus$.subscribe((status) => {
  console.log('WS Status:', status);
  toUiMsg$.next({type: 'ws-status', data: {status}});
});
